import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { AuthContext } from '../App';
import axios from 'axios';
import { Button } from './ui/button';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL;

export default function NotificationBell() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (user) {
      fetchNotifications();
      const interval = setInterval(fetchNotifications, 30000);
      return () => clearInterval(interval);
    }
  }, [user]);

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/api/notifications`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        withCredentials: true
      });
      setNotifications(response.data);
      setUnreadCount(response.data.filter(n => !n.read).length);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const markAsRead = async (notificationId, link) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/api/notifications/${notificationId}/read`, {}, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        withCredentials: true
      });
      fetchNotifications();
      if (link) navigate(link);
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  if (!user) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative border-2 border-black rounded-full"
        >
          <Bell className="w-5 h-5" />
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 w-5 h-5 bg-pink-400 border-2 border-black rounded-full text-xs font-bold flex items-center justify-center text-white">
              {unreadCount}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 border-4 border-black rounded-2xl p-0">
        <div className="p-4 border-b-2 border-black">
          <h3 className="font-black text-lg" style={{fontFamily: 'Outfit'}}>Notifications</h3>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {notifications.length === 0 ? (
            <div className="p-8 text-center text-slate-500">
              No notifications yet
            </div>
          ) : (
            notifications.map(notif => (
              <div
                key={notif.notification_id}
                onClick={() => markAsRead(notif.notification_id, notif.link)}
                className={`p-4 border-b border-slate-200 hover:bg-slate-50 cursor-pointer ${
                  !notif.read ? 'bg-lime-50' : ''
                }`}
              >
                <div className="font-bold text-sm">{notif.title}</div>
                <div className="text-xs text-slate-600 mt-1">{notif.message}</div>
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}